module.exports = __webpack_public_path__ + "static/media/main idea.fcdad4a1.mp3";